<matchmaking-result-page-header data-cy="header" [userName]="userName()" />

<div class="highlight-container">
  <button
    class="view-resources-button"
    data-cy="view-resources-button"
    siriusButton
    size="large"
    [buttonText]="translations()!.button.viewResources"
    buttonType="primary"
  (click)="scrollToAcademyTraining()"></button>

  <div class="highlight-container-text">
    <h2 class="highlight-title sir-text-style-title-m-default" data-cy="highlight-title">
      {{ translations()!.resultPage.highlightTitle }}
    </h2>
  </div>
  <div class="highlight-info-box-container">
    <sirius-text-html
      class="highlight-description sir-text-style-paragraph-l-default"
      data-cy="highlight-description"
      textStyleSize="l"
      [html]="translations()!.resultPage.highlightDescription">
    </sirius-text-html>
    <ng-template #highlightItems>
      @for (item of highlights(); track $index) {
        <matchmaking-info-box
          class="info-box"
          data-cy="info-box"
          [title]="getTranslation(item.translationTitleKey)!"
          [description]="getTranslation(item.translationDescriptionKey)!"
          [imageSrc]="item.imgSrc">
        </matchmaking-info-box>
      }
    </ng-template>

    <div class="highlights-desktop-view">
      <ng-container [ngTemplateOutlet]="highlightItems" />
    </div>
    <sirius-slider class="highlights-mobile-view">
      <ng-container [ngTemplateOutlet]="highlightItems" />
    </sirius-slider>
  </div>
</div>

<matchmaking-ebooks [ebooks]="ebooks() ?? []" [application]="application()" />

<ur-product-slider
  data-cy="product-slider"
  [products]="products()"
    [title]="
        translations()!.resultPage.productSliderTitle | interpolate: { application: application() }
    "
  [description]="translations()!.resultPage.productSliderDescription">
</ur-product-slider>

<matchmaking-case-stories [caseStories]="caseStories() ?? []" [application]="application()" />

<matchmaking-blog-posts [blogs]="blogs() ?? []" />

@if (academyTrainingContent()) {
  <div class="sirius-feature">
    <sirius-feature
      #academyTrainingElement
      [layout]="academyTrainingContent().layout"
      [title]="academyTrainingContent().title"
      [textHtml]="academyTrainingContent().textHtml || ''"
      [mediaItem]="academyTrainingContent().media"
      [button]="academyTrainingContent().button">
    </sirius-feature>
  </div>
}

@if (webinarsForYouContent()) {
  <div class="sirius-feature webinar">
    <sirius-feature
      [layout]="webinarsForYouContent().layout"
      [title]="webinarsForYouContent().title"
      [textHtml]="webinarsForYouContent().textHtml || ''"
      [mediaItem]="webinarsForYouContent().media"
      [button]="webinarsForYouContent().button">
    </sirius-feature>
  </div>
}

<matchmaking-key-benefits data-cy="key-benefits" [application]="application()" />
